// @flow
import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../services/apiService/apiService';
import { isAppointmentDelivery } from '../../../helper/DeliveryTypeHelper.js';
import { deliveryTypeStatusMap } from '../../../helper/DeliveryTypeHelper';

import {
  isPoDetailsVaild,
  isPoDetailsRequired
} from '../../../helper/PurchaseOrderHelper.js';

export const ceTaskboardActions = {
  GET_TASKBOARD_DATA: 'GET_TASKBOARD_DATA',
  UPDATE_PAGE_NUMBER: 'UPDATE_PAGE_NUMBER',
  UPDATE_PENDING_TASK_COUNT: 'UPDATE_PENDING_TASK_COUNT',
  UPDATE_FILTER: 'UPDATE_FILTER',
  GET_PO_DETAILS: 'GET_PO_DETAILS',
  GET_FC_NAME_HASH: 'GET_FC_NAME_HASH',
  DISABLE_ROW_BUTTONS: 'DISABLE_ROW_BUTTONS',
  DISABLE_SUBMIT_BUTTON: 'DISABLE_SUBMIT_BUTTON',
  SET_BULK_APPROVE_OR_REJECT_PROGRESS: 'SET_BULK_APPROVE_OR_REJECT_PROGRESS',
  UPDATE_TABLE: 'UPDATE_TABLE'
};

export const setBulkActionInProgessAction = payload => ({
  type: ceTaskboardActions.SET_BULK_APPROVE_OR_REJECT_PROGRESS,
  payload
});
export const getTaskboardDataAction = payload => ({
  type: ceTaskboardActions.GET_TASKBOARD_DATA,
  payload
});

export const updatePageNumber = payload => ({
  type: ceTaskboardActions.UPDATE_PAGE_NUMBER,
  payload
});

export const updatePendingTaskCount = payload => ({
  type: ceTaskboardActions.UPDATE_PENDING_TASK_COUNT,
  payload
});

export const updateFilter = (key, payload) => ({
  type: ceTaskboardActions.UPDATE_FILTER,
  key,
  payload
});

export const getPoDetailsAction = payload => ({
  type: ceTaskboardActions.GET_PO_DETAILS,
  payload
});

export const getFcNameHashAction = payload => ({
  type: ceTaskboardActions.GET_FC_NAME_HASH,
  payload
});

export const disableSubmitButton = payload => ({
  type: ceTaskboardActions.DISABLE_SUBMIT_BUTTON,
  payload
});

export const updateTaskBoardTable = payload => ({
  type: ceTaskboardActions.UPDATE_TABLE,
  payload
});

export const getFailedActionPayload = (res, defaultMessage) => ({
  isLoading: false,
  isLoaded: false,
  isPoDetailsLoading: false,
  isFcNameHashLoading: false,
  poDetails: null,
  fcNameHash: {},
  error: (res && res.errorMessage) || defaultMessage,
  boomerang: {
    component: 'toastr',
    type: 'error',
    removeExistingBms: true,
    heading: 'Error',
    message: (res && res.errorMessage) || defaultMessage,
    timeOut: 3000
  }
});

export const getTaskboardData = () => (dispatch, getState) => {
  const { ceTaskboardState } = getState();

  const isHolidayDeliveryRequest =
    ceTaskboardState &&
    ceTaskboardState.filters &&
    ceTaskboardState.filters.deliveryType === 'HOLIDAY_DELIVERY';

  dispatch(
    getTaskboardDataAction({
      isLoading: true,
      isLoaded: false
    })
  );
  let startDate =
    ceTaskboardState.filters.dateFilters &&
    ceTaskboardState.filters.dateFilters.fromDate;
  if (startDate) {
    startDate = parseInt(startDate);
    startDate = new Date(new Date(startDate).setHours(0, 0, 0, 0)).getTime();
  }
  let endDate =
    ceTaskboardState.filters.dateFilters &&
    ceTaskboardState.filters.dateFilters.toDate;
  if (endDate) {
    endDate = parseInt(endDate);
  }
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: isHolidayDeliveryRequest
      ? 'getHolidayDeliveryRequestData'
      : 'consignmentsAppointment',
    method: 'GET',
    replaceParamsArr: isHolidayDeliveryRequest
      ? [
          { key: 'pageNumber', val: ceTaskboardState.pageNumber + 1 },
          { key: 'pageSize', val: ceTaskboardState.pageSize }
        ]
      : [
          { key: 'deliveryType', val: ceTaskboardState.filters.deliveryType },
          {
            key: 'clientId',
            val:
              ceTaskboardState.filters.client &&
              ceTaskboardState.filters.client.id
          },
          { key: 'statuses', val: ceTaskboardState.filters.statuses },
          { key: 'toBeScheduled', val: ceTaskboardState.filters.toBeScheduled },
          { key: 'search', val: ceTaskboardState.filters.searchString },
          { key: 'pageNumber', val: ceTaskboardState.pageNumber + 1 },
          { key: 'pageSize', val: ceTaskboardState.pageSize },
          { key: 'fromDate', val: startDate },
          { key: 'toDate', val: endDate }
        ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getTaskboardDataAction({
            isLoading: false,
            isLoaded: true,
            taskboardData: res.payload,
            totalElements: res.totalElements
          })
        );
      } else {
        // eslint-disable-next-line
        console.log('Failure to getTaskboardDataAction ', res);
        dispatch(
          getTaskboardDataAction({
            isLoading: false,
            isLoaded: true,
            taskboardData: [],
            totalElements: 0
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to getTaskboardDataAction ', res);
      dispatch(
        getTaskboardDataAction({
          isLoading: false,
          isLoaded: true,
          taskboardData: [],
          totalElements: 0
        })
      );
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not get tasks'
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getTaskboardDataAction ', res);
      dispatch(
        getTaskboardDataAction({
          isLoading: false,
          isLoaded: true,
          taskboardData: [],
          totalElements: 0
        })
      );
      toastr.error('Something went wrong!', 'Could not get tasks');
    }
  };

  return makeApiCall(requestObj);
};

export const getConsignmentAppointmentSummary = () => (dispatch, getState) => {
  const { ceTaskboardState } = getState();
  let startDate =
    ceTaskboardState.filters.dateFilters &&
    ceTaskboardState.filters.dateFilters.fromDate;
  if (startDate) {
    startDate = parseInt(startDate);
    startDate = new Date(new Date(startDate).setHours(0, 0, 0, 0)).getTime();
  }
  let endDate =
    ceTaskboardState.filters.dateFilters &&
    ceTaskboardState.filters.dateFilters.toDate;
  if (endDate) {
    endDate = parseInt(endDate);
  }
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getConsignmentAppointmentSummary',
    replaceParamsArr: [
      { key: 'fromDate', val: startDate },
      { key: 'toDate', val: endDate }
    ],
    method: 'GET',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(updatePendingTaskCount(res.payload));
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to getConsignmentAppointmentSummary ', res);
      toastr.error(
        'Something went wrong!',
        res.errorMessage ||
          'Unable to fetch pending consignment appointment count.'
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getConsignmentAppointmentSummary ', res);
      toastr.error(
        'Something went wrong!',
        'Unable to fetch pending consignment appointment count.'
      );
    }
  };

  return makeApiCall(requestObj);
};

/**
 * This function will get FC Names List for delivery clients and store in fcNameHash
 * @param {list} deliveryClients // List of delivery clients for which we want to fetch FC Names List
 *
 */
export const getFcNameHash = deliveryClients => (dispatch: Function) => {
  dispatch(
    getFcNameHashAction({
      isFcNameHashLoading: true,
      fcNameHash: {}
    })
  );
  const promiseList = deliveryClients.map(client => {
    const requestObj = {
      baseUrl: 'zoomApiUrl',
      apiEndPoint: 'getFcName',
      method: 'GET',
      replaceParamsArr: [{ key: 'deliveryClient', val: client.toUpperCase() }],
      successCb: res => {
        if (res.status === 'SUCCESS') {
          dispatch(
            getFcNameHashAction({
              client,
              fcNameList: res.payload,
              isFcNameHashLoading: false
            })
          );
        } else {
          dispatch(
            getFcNameHashAction(
              getFailedActionPayload(res, 'Unable to get FC list.')
            )
          );
        }
      },
      failureCb: res =>
        dispatch(
          getFcNameHashAction(
            getFailedActionPayload(res || {}, 'Unable to get FC list.')
          )
        ),
      catchCb: res =>
        dispatch(
          getFcNameHashAction(
            getFailedActionPayload(res || {}, 'Unable to get FC list.')
          )
        )
    };
    return makeApiCall(requestObj);
  });
  return promiseList;
};

export const updateConsignmentAppointmentData = () => dispatch => {
  //dispatch(getConsignmentAppointmentSummary());
  //dispatch(getTaskboardData());
  dispatch(getFcNameHash(['AMAZON', 'FLIPKART']));
};

export const changeTaskStatus = (
  consignmentAppointmentData,
  newStatus,
  cb
) => dispatch => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'changeConsignmentsAppointmentStatus',
    method: 'POST',
    data: {
      id: consignmentAppointmentData.appointmentRecordId,
      consignmentId: consignmentAppointmentData.id,
      status: newStatus,
      deliveryType: consignmentAppointmentData.deliveryType
    },
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(updateConsignmentAppointmentData());
        toastr.success('Success', `Consignment appointment ${newStatus}`);
        if (
          newStatus === deliveryTypeStatusMap.REJECTED &&
          res.payload.remarks
        ) {
          toastr.info('Important Message', res.payload.remarks, {
            timeOut: 0
          });
        }
        cb();
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to changeTaskStatus ', res);
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Unable to APPROVE/REJECT appointment.'
      );
      cb();
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while changeTaskStatus ', res);
      toastr.error(
        'Something went wrong!',
        'Unable to APPROVE/REJECT appointment.'
      );
      cb();
    }
  };

  return makeApiCall(requestObj);
};

export const scheduleTask = (
  consignmentAppointmentData,
  onSucces,
  isNewTask
) => dispatch => {
  if (isNewTask && !consignmentAppointmentData.id) {
    return null;
  }
  if (isNewTask && consignmentAppointmentData.purchaseOrderDTOs) {
    const [isValid, errorMessage] = isPoDetailsVaild(
      consignmentAppointmentData.purchaseOrderDTOs,
      isPoDetailsRequired(consignmentAppointmentData.deliveryClient)
    );
    if (!isValid) {
      toastr.error('Error', errorMessage);
      return null;
    }
  }
  dispatch(
    disableSubmitButton({
      isSubmitButtonDisabled: true
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: isNewTask ? 'createAppointment' : 'scheduleAppointment',
    method: 'POST',
    data: {
      id: consignmentAppointmentData.appointmentRecordId,
      appointmentId: consignmentAppointmentData.appointmentId,
      appointmentTime: consignmentAppointmentData.appointmentTime,
      consignmentId: consignmentAppointmentData.id,
      deliveryType: consignmentAppointmentData.deliveryType,
      deliveryClient: consignmentAppointmentData.deliveryClient
    },
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(updateConsignmentAppointmentData());
        toastr.success(
          'Success',
          `${
            isNewTask
              ? 'Consignment Appointment created.'
              : 'Consignment Appointment scheduled.'
          }`
        );
        onSucces();
      }
      dispatch(
        disableSubmitButton({
          isSubmitButtonDisabled: false
        })
      );
    },
    failureCb: res => {
      dispatch(
        disableSubmitButton({
          isSubmitButtonDisabled: false
        })
      );
      // eslint-disable-next-line
      console.log('Failure to markUnmarkDacc ', res);
      toastr.error('Error', res.errorMessage || 'Something went wrong!');
    },
    catchCb: res => {
      dispatch(
        disableSubmitButton({
          isSubmitButtonDisabled: false
        })
      );
      // eslint-disable-next-line
      console.log('Exception while markUnmarkDacc ', res);
      toastr.error('Error', 'Something went wrong!');
    }
  };

  if (
    isNewTask &&
    isAppointmentDelivery(consignmentAppointmentData.deliveryType)
  ) {
    const purchaseOrderDetails = consignmentAppointmentData.purchaseOrderDTOs;
    if (
      !(
        !isPoDetailsRequired(consignmentAppointmentData.deliveryClient) &&
        purchaseOrderDetails &&
        purchaseOrderDetails.length === 1 &&
        purchaseOrderDetails[0].po === '' &&
        purchaseOrderDetails[0].units === '' &&
        !purchaseOrderDetails[0].poExpiryTime
      )
    ) {
      requestObj.data['deliveryClientCustomFieldsDTO'] = {
        purchaseOrderDTOs: consignmentAppointmentData.purchaseOrderDTOs,
        isFcNameRequired: isPoDetailsRequired(
          consignmentAppointmentData.deliveryClient
        ),
        ...(isPoDetailsRequired(consignmentAppointmentData.deliveryClient) && {
          fcName: consignmentAppointmentData.fcName
        })
      };
    }
  }

  return makeApiCall(requestObj);
};

export const markUnmarkDacc = (
  consignmentAppointmentData,
  onSucces
) => dispatch => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'markUnmarkDacc',
    method: 'PUT',
    replaceParamsArr: [
      { key: 'consignmentId', val: consignmentAppointmentData.id },
      { key: 'isDacc', val: !consignmentAppointmentData.isConsignmentDacc }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(updateConsignmentAppointmentData());
        toastr.success(
          'Success',
          `${
            consignmentAppointmentData.isConsignmentDacc ? 'Unmarked' : 'Marked'
          } Dacc for ${consignmentAppointmentData.cnote}`
        );
        onSucces();
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to markUnmarkDacc ', res);
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Unable to MARK/UNMARK consignment.'
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while markUnmarkDacc ', res);
      toastr.error(
        'Something went wrong!',
        'Unable to MARK/UNMARK appointment.'
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getConsignmentAppointmentDetails = (cnote, onSucces) => {
  if (!cnote || cnote.length !== 10) {
    return null;
  }
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getConsignmentAppointmentDetails',
    method: 'GET',
    pathVariables: [{ key: '{cnote}', val: cnote }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        onSucces(res.payload);
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to getConsignmentAppointmentDetails ', res);
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Unable to fetch consignment appointment details.'
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getConsignmentAppointmentDetails ', res);
      toastr.error(
        'Something went wrong!',
        'Unable to fetch consignment appointment details.'
      );
    }
  };

  return makeApiCall(requestObj);
};

export const downloadBulkAppointmentSample = () => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'appointmentSheetTemplate',
    method: 'GET',
    responseType: 'arraybuffer',
    successCb: res => {
      const blob = new Blob([res], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'appointment_sheet_template.xlsx';
      link.click();
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to downloadBulkAppointmentSample ', res);
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Unable to download sample template.'
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while downloadBulkAppointmentSample ', res);
      toastr.error(
        'Something went wrong!',
        'Unable to download sample template.'
      );
    }
  };

  return makeApiCall(requestObj);
};

export const bulkUploadAppointment = (file, onSuccess) => dispatch => {
  if (!file) {
    toastr.error('Error!', 'Please select a file.');
    return null;
  }

  const formData = new FormData();
  formData.append('data', file);

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'bulkUploadAppointment',
    method: 'POST',
    postFormData: true,
    data: formData,
    contentType: '',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(updateConsignmentAppointmentData());
        const errorList = res.payload.filter(obj => obj.status !== 'Success');
        onSuccess(errorList);
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to bulkUploadAppointment ', res);
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Unable to bulk upload consignment appointment.'
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while bulkUploadAppointment ', res);
      toastr.error(
        'Something went wrong!',
        'Unable to bulk upload consignment appointment.'
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getPoDetailsByConsignmentId = (consignmentId: number) => (
  dispatch: Function
) => {
  dispatch(
    getPoDetailsAction({
      isPoDetailsLoading: true,
      poDetails: []
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getPoDetailsByConsignmentId',
    method: 'GET',
    replaceParamsArr: [{ key: 'consignmentId', val: consignmentId }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getPoDetailsAction({
            poDetails: res.payload,
            isPoDetailsLoading: false
          })
        );
      } else {
        dispatch(
          getPoDetailsAction(
            getFailedActionPayload(res, 'Unable to get PO details.')
          )
        );
      }
    },
    failureCb: res =>
      dispatch(
        getPoDetailsAction(
          getFailedActionPayload(res || {}, 'Unable to get PO details.')
        )
      ),
    catchCb: res =>
      dispatch(
        getPoDetailsAction(
          getFailedActionPayload(res || {}, 'Unable to get PO details.')
        )
      )
  };
  return makeApiCall(requestObj);
};

const removeToastrs = () => {
  toastr.removeByType('success');
  toastr.removeByType('error');
  toastr.removeByType('light');
};

export const approveHolidayDeliveryRequest = (cnote, cb) => dispatch => {
  removeToastrs();
  toastr.light('Processing', 'Please Wait!');
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'approveHolidayDeliveryRequest',
    method: 'POST',
    replaceParamsArr: [{ key: 'cnote', val: cnote || '' }],
    successCb: res => {
      if (res && res.status === 'SUCCESS') {
        if (res.payload) {
          dispatch(getTaskboardData());
          removeToastrs();
          toastr.success('Success', 'Approved Successfully');
          cb();
        } else {
          removeToastrs();
          toastr.error('Error', 'Something went wrong!');
          cb();
        }
      } else {
        removeToastrs();
        toastr.error('Error', 'Something went wrong!');
        cb();
      }
    },
    failureCb: res => {
      removeToastrs();
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Unable to approve holiday delivery request'
      );
      cb();
    },
    catchCb: () => {
      removeToastrs();
      toastr.error(
        'Something went wrong!',
        'Unable to approve holiday delivery request'
      );
      cb();
    }
  };

  return makeApiCall(requestObj);
};

export const rejectHolidayDeliveryRequest = (data, cb) => dispatch => {
  removeToastrs();
  toastr.light('Processing', 'Please Wait!');
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'rejectHolidayDeliveryRequest',
    method: 'POST',
    replaceParamsArr: [
      { key: 'cnote', val: data.cnote || '' },
      { key: 'reasonForRejection', val: data.reasonForRejection || '' }
    ],
    successCb: res => {
      if (res && res.status === 'SUCCESS') {
        if (res.payload) {
          dispatch(getTaskboardData());
          removeToastrs();
          toastr.success('Success', 'Rejected Successfully');
          cb();
        } else {
          removeToastrs();
          toastr.error('Error', 'Something went wrong!');
          cb();
        }
      } else {
        removeToastrs();
        toastr.error('Error', 'Something went wrong!');
        cb();
      }
    },
    failureCb: res => {
      removeToastrs();
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Unable to reject holiday delivery request'
      );
      cb();
    },
    catchCb: () => {
      removeToastrs();
      toastr.error(
        'Something went wrong!',
        'Unable to reject holiday delivery request'
      );
      cb();
    }
  };

  return makeApiCall(requestObj);
};

export const bulkApproveOrReject = (data, callback) => dispatch => {
  dispatch(setBulkActionInProgessAction(true));
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'bulkApproveOrRejectCeTaskDashBoard',
    data,
    method: 'POST',
    successCb: res => {
      dispatch(setBulkActionInProgessAction(false));
      if (res.status === 'SUCCESS') {
        toastr.success('Success', res.payload, {
          timeOut: 5000
        });
        dispatch(getTaskboardData());
        if (callback) {
          callback();
        }
      } else if (res.status === 'FAILURE') {
        toastr.error('Error', res.errorMessage || 'Something went wrong');
      }
    },
    failureCb: res => {
      dispatch(setBulkActionInProgessAction(false));
      toastr.error('Error', 'Something went wrong');
    },
    catchCb: res => {
      dispatch(setBulkActionInProgessAction(false));
      toastr.error('Error', 'Something went wrong');
    }
  };
  makeApiCall(requestObj);
};
